import React, { useMemo, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import KendoPatientFormGrid from "./KendoPatientFormGrid";
import KendoKioskFormGrid from "./KendoKioskFormGrid";
import { DisplayMsg } from "../../../../../services/toastService";
import { setUrl } from "../../../../../handlers";
import { DeleteData, PostData, UpdateData } from "../../../../../utils/array";

const JotForm = (props) => {
  const sharedData = useSelector((state) => state.SharedLayoutData);
  const [KioskData, setKiosKData] = useState({
    formName: "",
    jotUrl: "",
    documentType: "P",
    optional: "Y",
    jotField: "",
    update: false,
    formId: "",
  });
  const [reload, setReload] = useState({ kiosk: false, patient: false });
  const [PatientData, setPatientData] = useState({
    formName: "",
    jotUrl: "",
    jotField: "",
    smartType: "N",
    jotFormId: "",
    update: false,
    formId: "",
  });
  const [Error, setError] = useState({
    kiosKForm: "",
    kiosUrl: "",
    kioskJot: "",
    patientForm: "",
    patientUrl: "",
    patientJot: "",
  });
  const UrlPlaceholder = `https://form.jotform.com/211376869175467`;

  const KioskState = useMemo(
    () => ({
      reRender: reload.kiosk,
    }),
    [reload.kiosk]
  );

  const PatientState = useMemo(
    () => ({
      reRender: reload.patient,
    }),
    [reload.patient]
  );

  const Documents = [
    {
      label: "Initial Visit (P)",
      value: "P",
    },
    {
      label: "All Visit (V)",
      value: "V",
    },
  ];

  const Optionals = [
    {
      label: "Y",
      value: "Y",
    },
    {
      label: "N",
      value: "N",
    },
  ];

  const SmartOptions = [
    {
      label: "Yes",
      value: "Y",
    },
    {
      label: "No",
      value: "N",
    },
  ];

  const AlterJotForm = (event, type) => {
    const { name } = event.target;
    const curVal = event.target.value;
    if (type === "patient") {
      setPatientData((faxInfo) => ({
        ...faxInfo,
        [name]: curVal,
      }));
    } else if (type === "kiosk") {
      setKiosKData((kiosInfo) => ({
        ...kiosInfo,
        [name]: curVal,
      }));
    }
    ShowErrorMsg(name, curVal, type);
  };

  let ShowErrorMsg = (field, value, type) => {
    if (type === "kiosk") {
      if (field === "formName") {
        if (value.length > 5) {
          setError((errorInfo) => ({
            ...errorInfo,
            kiosKForm: "",
          }));
        } else {
          setError((errorInfo) => ({
            ...errorInfo,
            kiosKForm: "Form Name Must Be Greater Then 5 Characters.",
          }));
        }
      }

      if (field === "jotUrl") {
        if (value.substring(0, 35).includes("jotform.com") === false) {
          setError((errorInfo) => ({
            ...errorInfo,
            kiosUrl: "Must include (jotform.com)",
          }));
        } else {
          setError((errorInfo) => ({
            ...errorInfo,
            kiosUrl: "",
          }));
        }
      }

      if (field === "jotField") {
        if (value.length > 0) {
          setError((errorInfo) => ({
            ...errorInfo,
            kioskJot: "",
          }));
        } else {
          setError((errorInfo) => ({
            ...errorInfo,
            kioskJot: "Please Mention Jot Form Fields.",
          }));
        }
      }
    } else {
      if (field === "formName") {
        if (value.length > 5) {
          setError((errorInfo) => ({
            ...errorInfo,
            patientForm: "",
          }));
        } else {
          setError((errorInfo) => ({
            ...errorInfo,
            patientForm: "Form Name Must Be Greater Then 5 Characters.",
          }));
        }
      }

      if (field === "jotUrl") {
        if (value.substring(0, 35).includes("jotform.com") === false) {
          setError((errorInfo) => ({
            ...errorInfo,
            patientUrl: "Must include (jotform.com)",
          }));
        } else {
          setError((errorInfo) => ({
            ...errorInfo,
            patientUrl: "",
          }));
        }
      }

      if (field === "jotField") {
        if (value.length > 0) {
          setError((errorInfo) => ({
            ...errorInfo,
            patientJot: "",
          }));
        } else {
          setError((errorInfo) => ({
            ...errorInfo,
            patientJot: "Please Mention Jot Form Fields.",
          }));
        }
      }
    }
  };

  const KioskSetup = async () => {
    let isValid = true;
    if (KioskData.formName.length < 5) {
      setError((errorInfo) => ({
        ...errorInfo,
        kiosKForm: "Form Name Must Be Greater Then 5 Characters.",
      }));
      isValid = false;
    }
    if (KioskData.jotUrl.substring(0, 35).includes("jotform.com") === false) {
      setError((errorInfo) => ({
        ...errorInfo,
        kiosUrl: "Must include (jotform.com)",
      }));
      isValid = false;
    }

    if (KioskData.jotField.length < 1) {
      setError((errorInfo) => ({
        ...errorInfo,
        kioskJot: "Please Mention Jot Form Fields.",
      }));
      isValid = false;
    }

    if (isValid) {
      const formData = new FormData();
      formData.append("EntitySeq_num", sessionStorage.ENTITY_SEQ_NUM);
      formData.append("TNSName", sessionStorage.tnsName);
      formData.append("FormName", KioskData.formName);
      formData.append("JotUrl", KioskData.jotUrl);
      formData.append("formId", KioskData.formId);
      formData.append("DocType", KioskData.documentType);
      formData.append("OptType", KioskData.optional);
      formData.append("JotFields", KioskData.jotField);

      const kioskInfo = {
        FormName: KioskData.formName,
        DocumentType: KioskData.documentType,
        Optional: KioskData.optional,
        JotFields: KioskData.jotField,
        FilePath: KioskData.jotUrl,
        facilityId:
          sharedData.currentFacilityId === 0
            ? ""
            : sharedData.currentFacilityId.toString(),
        id: KioskData.formId === "" ? null : KioskData.formId,
      };

      document.getElementById("loader").style.display = "block";

      const response =
        PatientData.formId !== ""
          ? await UpdateData(
              `Practice/${sharedData.currentEntityId}/kioskForm`,
              kioskInfo,
              "PEHR",
              null,
              sharedData.clientApiKey
            )
          : await PostData(
              `Practice/${sharedData.currentEntityId}/kioskForm`,
              kioskInfo,
              "PEHR",
              sharedData.clientApiKey
            );
      if (response && response.succeeded) {
        DisplayMsg("1", response.message);
        setReload((prevReload) => ({
          ...prevReload,
          kiosk: !reload.kiosk,
        }));

        setKiosKData((kiosInfo) => ({
          ...kiosInfo,
          formName: "",
          jotUrl: "",
          jotField: "",
          documentType: "",
          optional: "",
          update: false,
          formId: "",
        }));

        document.getElementById("loader").style.display = "none";
      } else {
        DisplayMsg("2", response.Message);
      }
    } else {
    }
  };

  const PatientSetup = async () => {
    let isValid = true;
    if (PatientData.formName.length < 5) {
      setError((errorInfo) => ({
        ...errorInfo,
        patientForm: "Form Name Must Be Greater Then 5 Characters.",
      }));
      isValid = false;
    }
    if (PatientData.jotUrl.substring(0, 35).includes("jotform.com") === false) {
      setError((errorInfo) => ({
        ...errorInfo,
        patientUrl: "Must include (jotform.com)",
      }));
      isValid = false;
    }

    if (PatientData.jotField.length < 1) {
      setError((errorInfo) => ({
        ...errorInfo,
        patientJot: "Please Mention Jot Form Fields.",
      }));
      isValid = false;
    }

    if (isValid) {
      document.getElementById("loader").style.display = "block";
      const patientFormInfo = {
        Title: PatientData.formName,
        FilePath: PatientData.jotUrl,
        Optional: PatientData.optional,
        JotFields: PatientData.jotField,
        SmartForm: PatientData.smartType,
        JotFormId: PatientData.jotFormId,
        facilityId:
          sharedData.currentFacilityId === 0
            ? ""
            : sharedData.currentFacilityId.toString(),
        Id: PatientData.formId === "" ? 0 : PatientData.formId,
      };

      document.getElementById("loader").style.display = "block";
      const response =
        PatientData.formId !== ""
          ? await UpdateData(
              `Practice/${sharedData.currentEntityId}/patientForm`,
              patientFormInfo,
              "PEHR",
              null,
              sharedData.clientApiKey
            )
          : await PostData(
              `Practice/${sharedData.currentEntityId}/patientForm`,
              patientFormInfo,
              "PEHR",
              sharedData.clientApiKey
            );

      if (response && response.succeeded) {
        DisplayMsg("1", response.message);
        setReload((prevReload) => ({
          ...prevReload,
          patient: !reload.patient,
        }));

        setPatientData((prevInfo) => ({
          ...prevInfo,
          formName: "",
          jotUrl: "",
          jotField: "",
          jotFormId: "",
          smartType: "N",
          update: false,
          formId: "",
        }));
        document.getElementById("loader").style.display = "none";
      } else {
        DisplayMsg("2", response.message);
      }
    } else {
    }
  };

  const DeleteKiosKForm = async () => {
    if (KioskData.formId != null && KioskData.formId !== "") {
      document.getElementById("loader").style.display = "block";
      const formData = new FormData();
      formData.append("EntitySeq_num", sessionStorage.ENTITY_SEQ_NUM);
      formData.append("TNSName", sessionStorage.tnsName);
      formData.append("formId", KioskData.formId);

      const queryParams = new URLSearchParams({
        facilityId: "",
        formId: KioskData.formId,
      }).toString();

      const response = await DeleteData(
        `Practice/${sharedData.currentEntityId}/kioskForm`,
        "PEHR",
        queryParams,
        sharedData.clientApiKey
      );

      if (response && response.succeeded) {
        DisplayMsg("1", response.message);
        setReload((prevReload) => ({
          ...prevReload,
          kiosk: !reload.kiosk,
        }));

        setKiosKData((kiosInfo) => ({
          ...kiosInfo,
          formName: "",
          jotUrl: "",
          jotField: "",
          documentType: "",
          optional: "",
          update: false,
          formId: "",
        }));
        document.getElementById("loader").style.display = "none";
      } else {
        DisplayMsg("2", response.message);
      }
    }
  };

  const DeletePatientForm = async () => {
    if (PatientData.formId != null && PatientData.formId !== "") {
      document.getElementById("loader").style.display = "block";
      const formData = new FormData();
      formData.append("EntitySeq_num", sessionStorage.ENTITY_SEQ_NUM);
      formData.append("TNSName", sessionStorage.tnsName);
      formData.append("formId", PatientData.formId);
      const result = await fetch(
        setUrl("PRACTICEDETAIL", "REMOVEPATIENTFORM"),
        {
          method: "POST",
          body: formData,
        }
      );
      const response = await result.json();
      if (response && response.status) {
        DisplayMsg("1", response.Message);
        setReload((prevReload) => ({
          ...prevReload,
          patient: !reload.patient,
        }));

        setPatientData((kiosInfo) => ({
          ...kiosInfo,
          formName: "",
          jotUrl: "",
          jotField: "",
          documentType: "",
          optional: "",
          update: false,
          formId: "",
        }));
        document.getElementById("loader").style.display = "none";
      } else {
        DisplayMsg("2", response.Message);
      }
    }
  };

  const UpdatedKioskForm = useCallback(
    (KioskInfo) => {
      setKiosKData((prevInfo) => ({
        ...prevInfo,
        formName: KioskInfo.formName,
        jotUrl: KioskInfo.jotUrl,
        jotField: KioskInfo.jotField,
        documentType: KioskInfo.documentType,
        optional: KioskInfo.optional,
        update: KioskInfo.update,
        formId: KioskInfo.formId,
      }));
    },
    [reload.kiosk]
  );

  const UpdatedPatientForm = useCallback((PatientInfo) => {
    setPatientData((prevInfo) => ({
      ...prevInfo,
      formName: PatientInfo.formName,
      jotUrl: PatientInfo.jotUrl,
      jotField: PatientInfo.jotField,
      smartType: "N",
      jotFormId: PatientInfo.jotFormId,
      formId: PatientInfo.formId,
      update: PatientInfo.update,
    }));

    setError((errorInfo) => ({
      ...errorInfo,
      kiosKForm: "",
      kiosUrl: "",
      kioskJot: "",
      patientForm: "",
      patientUrl: "",
      patientJot: "",
    }));
  }, []);

  return (
    <div className="row">
      <div className="col-md-6 col-sm-12">
        <div className="row table-panel-header mt-4 bg-white">
          <div className="col-md-6">
            <h6>Kiosk Forms</h6>
          </div>

          {/* {KioskData.update && (
              <div className="col-md-6 text-center">
                {sessionStorage.getItem("type") !== "CS" &&
                  sessionStorage.getItem("type") !== "CSM" && (
                    <input
                      type="button"
                      className="btnLinkRed btnUpdate"
                      value="Delete"
                      onClick={() => DeleteKiosKForm()}
                    />
                  )}
              </div>
            )} */}
        </div>
        <div className="col-md-12 col-sm-12">
          <div className="field-container">
            <label className="field-placeholder font-medium">
              Form Name <span className="redboxRequired" />
            </label>
            <input
              type="text"
              className="field-input"
              name="formName"
              value={KioskData.formName}
              onChange={(e) => AlterJotForm(e, "kiosk")}
            />
          </div>
          <label className="requiredtext text-xs">{Error.kiosKForm}</label>
        </div>
        <div className="col-md-12 col-sm-12">
          <div className="field-container">
            <label className="field-placeholder font-medium">
              JOT URL <span className="redboxRequired" />
            </label>
            <input
              type="text"
              className="field-input"
              name="jotUrl"
              placeholder={UrlPlaceholder}
              onChange={(e) => AlterJotForm(e, "kiosk")}
              value={KioskData.jotUrl}
            />
          </div>
          <label className="requiredtext text-xs">{Error.kiosUrl}</label>
        </div>
        <div className="col-md-12 col-sm-12">
          <div className="field-container">
            <label className="field-placeholder font-medium">
              Document Type <span className="redboxRequired" />
            </label>
            <select
              className="field-input"
              name="documentType"
              onChange={(e) => AlterJotForm(e, "kiosk")}
              value={KioskData.documentType}
            >
              {Documents.map((option) => (
                <option value={option.value}>{option.label}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="col-md-12 col-sm-12">
          <div className="field-container">
            <label className="field-placeholder font-medium">
              Optional <span className="redboxRequired" />
            </label>
            <select
              className="field-input"
              name="optional"
              onChange={(e) => AlterJotForm(e, "kiosk")}
              value={KioskData.optional}
            >
              {Optionals.map((option) => (
                <option value={option.value}>{option.label}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="col-md-12 col-sm-12">
          <label className="field-placeholder label-top-text font-medium">
            Jot Fields <span className="redboxRequired" />
          </label>
          <textarea
            rows="2"
            type="text"
            cols="20"
            className="w-100 mt-3 h-50"
            placeholder="Account,Number,Dob,..."
            maxLength="300"
            name="jotField"
            value={KioskData.jotField}
            onChange={(e) => AlterJotForm(e, "kiosk")}
          />
          <label className="requiredtext text-xs mt-0">{Error.kioskJot}</label>
        </div>
        <div className="col-md-12 col-sm-12 text-center">
          {sessionStorage.getItem("type") !== "CS" &&
            sessionStorage.getItem("type") !== "CSM" && (
              <input
                type="button"
                className="btnLinkGreen btnUpdate"
                value={KioskData.update ? "Update" : "Save"}
                onClick={() => KioskSetup()}
              />
            )}
        </div>
        <div className="col-md-12 col-sm-12 mt-2 kioskGrid">
          <div
            className="table-panel-body"
            style={{
              border: "1px solid rgba(0, 0, 0, .12)",
              borderTop: "none",
              borderBottom: "none",
            }}
            id="kioskGrid"
          >
            <KendoKioskFormGrid
              ParentCallBack={UpdatedKioskForm}
              reRender={KioskState}
              entityId={props.entityId}
            />
          </div>
        </div>
      </div>
      <div className="col-md-6 col-sm-12">
        <div className="row table-panel-header mt-4 bg-white">
          <div className="col-md-6">
            <h6>Patient Forms</h6>
          </div>

          {/* {PatientData.update && (
              <div className="col-md-6 text-center">
                {sessionStorage.getItem("type") !== "CS" &&
                  sessionStorage.getItem("type") !== "CSM" && (
                    <input
                      type="button"
                      className="btnLinkRed btnUpdate"
                      value="Delete"
                      onClick={() => DeletePatientForm()}
                    />
                  )}
              </div>
            )} */}
        </div>
        <div className="col-md-12 col-sm-12">
          <div className="field-container">
            <label className="field-placeholder font-medium">
              Form Name <span className="redboxRequired" />
            </label>
            <input
              type="text"
              className="field-input"
              name="formName"
              value={PatientData.formName}
              onChange={(e) => AlterJotForm(e, "patient")}
            />
          </div>
          <label className="requiredtext text-xs">{Error.patientForm}</label>
        </div>

        <div className="col-md-12 col-sm-12">
          <div className="field-container">
            <label className="field-placeholder font-medium">
              JOT URL <span className="redboxRequired" />
            </label>
            <input
              placeholder="https://form.jotform.com/211376869175467"
              type="text"
              className="field-input"
              name="jotUrl"
              onChange={(e) => AlterJotForm(e, "patient")}
              value={PatientData.jotUrl}
            />
          </div>
          <label className="requiredtext text-xs">{Error.patientUrl}</label>
        </div>

        <div className="col-md-12 col-sm-12">
          <div className="field-container">
            <label className="field-placeholder font-medium">Smart Form</label>
            <select
              className="field-input"
              name="smartType"
              onChange={(e) => AlterJotForm(e, "patient")}
              value={PatientData.smartType}
            >
              {SmartOptions.map((option) => (
                <option value={option.value}>{option.label}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="col-md-12 col-sm-12">
          <div className="field-container">
            <label className="field-placeholder font-medium">JotForm ID</label>
            <input
              type="text"
              className="field-input"
              name="jotFormId"
              value={PatientData.jotFormId}
              onChange={(e) => AlterJotForm(e, "patient")}
            />
          </div>
        </div>

        <div className="col-md-12 col-sm-12">
          <div>
            <label className="field-placeholder label-top-text font-medium">
              Jot Fields <span className="redboxRequired" />
            </label>
            <textarea
              rows="2"
              type="text"
              cols="20"
              className="field-input w-100 mt-3 h-50"
              placeholder="Account,Number,Dob,..."
              maxLength="300"
              name="jotField"
              value={PatientData.jotField}
              onChange={(e) => AlterJotForm(e, "patient")}
            />
            <label className="requiredtext text-xs mt-0">
              {Error.patientJot}
            </label>
          </div>
        </div>
        <div className="col-md-12 col-sm-12 text-center">
          {sessionStorage.getItem("type") !== "CS" &&
            sessionStorage.getItem("type") !== "CSM" && (
              <input
                type="button"
                className="btnLinkGreen btnUpdate"
                value={PatientData.update ? "Update" : "Save"}
                onClick={() => PatientSetup()}
              />
            )}
        </div>
        <div className="col-md-12 col-sm-12 mt-2">
          <div
            className="table-panel-body patientGrid"
            style={{
              border: "1px solid rgba(0, 0, 0, .12)",
              borderTop: "none",
              borderBottom: "none",
            }}
            id="patientGrid"
          >
            <KendoPatientFormGrid
              ParentCallBack={UpdatedPatientForm}
              reRender={PatientState}
              entityId={props.entityId}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default JotForm;
